/**
 * Agent type labels mapping
 */
export const AGENT_TYPE_LABELS = {
  SUPPORT_INTERNAL: 'Employee Support',
  SUPPORT_EXTERNAL: 'Customer Support',
  SEGMENT_BUILDER: 'Segment Builder',
  VANILLA: 'Passthrough',
  MERGE_TAG: 'Template Builder',
  JOURNEY_BUILDER: 'Journey Builder'
};

/**
 * Get human-readable label for agent type
 * @param {string} agentType - Agent type key
 * @returns {string} Human-readable label
 */
export const getAgentTypeLabel = agentType => {
  return AGENT_TYPE_LABELS[agentType] || agentType;
};